<template>
  <NuxtLayout>
    <!-- НЕ повертати сюди `appear`. На ньому SSR-компілятор Vue загортає
         ВЕСЬ вміст сторінки в літеральний <template> (ssrProcessTransition),
         а його вміст браузер тримає в інертному фрагменті й не малює до
         гідрації. Ціна була: LCP 7.0 с (з них 5.8 с — render delay), CLS
         0.227 (футер стрибав, коли вміст нарешті вставлявся) і знецінений
         SSR із пунктів 9а/9б/9г. Перехід між сторінками працює й без
         appear — він і потрібен лише для першого монтування. -->
    <Transition name="page">
      <NuxtPage :key="$route.path" />
      <!-- не використовуємо fullPath -->
    </Transition>
    <UiConfirm />
    <UiToaster />
  </NuxtLayout>
</template>

<script setup>
// нічого не потрібно
</script>

<style>
/* Глобальні стилі анімації сторінок */
.page-enter-active,
.page-leave-active {
  transition: opacity 0.18s ease;
}
.page-enter-from,
.page-leave-to {
  opacity: 0;
}
</style>
